export default function get_description(question, lang = 'default') {
    return (typeof question.description === 'object') ? question.description?.[lang] || question.description?.default : question.description;
}